import { useContext, useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { toast } from "react-toastify";
import { parseNumber } from "@telerik/kendo-intl";
import { ComboBoxChangeEvent } from "@progress/kendo-react-dropdowns";
import { StyledFlexAlignEnd } from "../FtlTab/FtlRouteHeader/FtlRouteHeader";
import { EditProjectContext } from "../../EditProjectContext";
import { SfMultiColumnDropDown } from "../FtlTab/InboundPipeline/SfMultiColumnDropDown";
import { LtlPipelineRoutingEmptyAndSpdrOrPdsrOutOfScopeProps } from "./isLtlPipelineRoutingEmptyAndSpdrOrPdsrOutOfScope";
import { isProjectReadOnly } from "../../IsProjectReadOnly";

type Props = {
  disabled?: boolean;
};

export const SetGlobalLtlShipFrequencyButton = ({
  disabled,
  isLtlPipelineRoutingEmptyAndSpdrOrPdsrOutOfScope,
}: Props & LtlPipelineRoutingEmptyAndSpdrOrPdsrOutOfScopeProps) => {
  const { project, setProject } = useContext(EditProjectContext);
  const [shipFrequency, setShipFrequency] = useState<undefined | string | number | string[]>(
    project.GlobalLtlShipFrequency
  );

  const setGlobalLtlShipFrequency = () => {
    if (!shipFrequency) {
      throw new Error("No ship frequency provided");
    }

    const globalLtlShipFrequency = parseNumber(shipFrequency as string);

    const isNewValueValidFrequency =
      project.ValidShippingFrequencies?.includes(globalLtlShipFrequency);

    if (!isNewValueValidFrequency) {
      toast("Please enter a valid ship frequency", {
        type: "error",
      });
      return;
    }

    // change supplier ship frequency for every ltl pipeline in the current project
    project.ltlPipelines?.forEach((ltlPipeline) => {
      ltlPipeline.SupplierShipFrequency = globalLtlShipFrequency;
    });
    project.GlobalLtlShipFrequency = globalLtlShipFrequency;

    setProject(project);
  };

  const onChange = (event: ComboBoxChangeEvent) => {
    if (!event.target.value) {
      return;
    }
    setShipFrequency(event.target.value.value);
  };

  return (
    <div style={{ width: "100%" }}>
      <StyledFlexAlignEnd>
        <SfMultiColumnDropDown
          onChange={onChange}
          value={shipFrequency}
          label="Global LTL Ship Frequency"
          disabled={disabled || isLtlPipelineRoutingEmptyAndSpdrOrPdsrOutOfScope}
        />

        <Button
          onClick={setGlobalLtlShipFrequency}
          disabled={
            disabled ||
            isProjectReadOnly(project) ||
            !shipFrequency ||
            isLtlPipelineRoutingEmptyAndSpdrOrPdsrOutOfScope
          }
        >
          Set
        </Button>
      </StyledFlexAlignEnd>
    </div>
  );
};
